import script from "./AdminView.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminView.vue?vue&type=script&setup=true&lang=js"

import "./AdminView.vue?vue&type=style&index=0&id=3247678f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3247678f"]])

export default __exports__